<script setup>
import { ref , onMounted} from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import { useFetch } from './useFetch.js'

const props = defineProps({
  category: String,
  slug: String,
})

const newsList = ref()
const emit = defineEmits(['loaded'])
const url = `/api/news.json?by=slug&${props.category}=${props.slug}`

onMounted(() => {
  useFetch(url)
    .then((data) => {
      newsList.value = data.news
      emit('loaded', newsList.value)
    })
    .catch((error) => {
      console.error(error)
    })
})


</script>

<template>
  <li v-for="news in newsList" :key="news.newsID" class="isotope-item hover-item">
    <Link :href="`/news/${news.newsCategory}/${news.newsSlug}`">
      <img :src="replaceS3path(news.newsThumb)" :alt="stripslashes(news.newsTitle)" class="w-full" />
      <h4 class="title hidden">{{ news.newsTitle }}</h4>
    </Link>
  </li>
</template>
